/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * One place a store holds stock, as the warehouse pickers need it (ENG-7040). \[id\] is the location's Shopify GID and is what the picker keys on. A name is editable in the Shopify admin and nothing says it is unique, so keying on it would let picking the second of two same-named locations write the first one's postal code --- a wrong lane, chosen by the picker built to stop wrong lanes. \[postalCode\] is nullable because Shopify's is: a location can exist with no address. That is worth showing rather than hiding, because it is the reason a warehouse rule would never match --- the postal code is what a quoted origin is compared against.
 * @export
 * @interface ShopifyStoreLocation
 */
export interface ShopifyStoreLocation {
  /**
   *
   * @type {string}
   * @memberof ShopifyStoreLocation
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyStoreLocation
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyStoreLocation
   */
  postalCode?: string | null;
}

/**
 * Check if a given object implements the ShopifyStoreLocation interface.
 */
export function instanceOfShopifyStoreLocation(
  value: object,
): value is ShopifyStoreLocation {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function ShopifyStoreLocationFromJSON(json: any): ShopifyStoreLocation {
  return ShopifyStoreLocationFromJSONTyped(json, false);
}

export function ShopifyStoreLocationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyStoreLocation {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    name: json["name"],
    postalCode: json["postalCode"] == null ? undefined : json["postalCode"],
  };
}

export function ShopifyStoreLocationToJSON(json: any): ShopifyStoreLocation {
  return ShopifyStoreLocationToJSONTyped(json, false);
}

export function ShopifyStoreLocationToJSONTyped(
  value?: ShopifyStoreLocation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    postalCode: value["postalCode"],
  };
}
